import { createContext, useContext } from "react";

export const BookingContext = createContext(() => {});
export const useBooking = () => useContext(BookingContext);

const STORAGE_KEY = "ft_booking_submitted";
export const PAYMENT_URL = "https://rzp.io/rzp/SNTAdfc";

export const isFormSubmitted = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const markFormSubmitted = () => {
  try {
    localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    // storage unavailable
  }
};

export const getSavedBooking = () => {
  return isFormSubmitted() ? { paymentUrl: PAYMENT_URL } : null;
};

export const saveBooking = () => {
  markFormSubmitted();
};

export const openPaymentPage = () => {
  window.open(PAYMENT_URL, "_blank", "noopener,noreferrer");
};

export const openTallyPopup = () => {
  if (typeof window !== "undefined" && window.Tally) {
    window.Tally.openPopup("D4Qgzq", {
      layout: "modal",
      width: 620,
      autoClose: 1500,
      onSubmit: () => {
        markFormSubmitted();
        openPaymentPage();
      },
    });
  } else {
    window.open("https://tally.so/r/D4Qgzq", "_blank");
  }
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84 });
  else el.scrollIntoView({ behavior: "smooth" });
};
